const INIT_AUTH_VALUE = {
    keycloak: {},
    isThaidLinked: false,
    thaidProviderUserId: null,
};

const state = () => {
    return {
        ...INIT_AUTH_VALUE
    };
};

// actions
const actions = {
    clearStore({
        commit
    }) {
        commit("clearStore");
    },
    setStore({
        commit
    }, store) {
        commit("setStore", store);
    },
    setToken({
        commit
    }, token) {
        commit("setToken", token);
    },
    setThaidLinkStatus({
        commit
    }, { linked, providerUserId }) {
        commit("setThaidLinkStatus", { linked, providerUserId });
    },
};

// mutations
const mutations = {
    clearStore(state) {
        Object.assign(state, INIT_AUTH_VALUE);
    },
    setStore(state, store) {
        Object.assign(state, store);
    },
    setToken(state, token) {
        state.token = token;
    },
    setThaidLinkStatus(state, { linked, providerUserId }) {
        state.isThaidLinked = linked;
        state.thaidProviderUserId = providerUserId;
    },
};

// getters
const getters = {
    getAllKeycloak: (state) => state,
    isAuth: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return true;
        } else {
            return false;
        }
    },
    getToken: (state) => state.token,
    getCreateLoginUrl: (state) => state.createLoginUrl,
    getAuthenticated: (state) => state.authenticated,
    getTokenParsed: (state) => state.tokenParsed,
    getUserAuth: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return true
        } else {
            return false
        }
    },
    getUserRoleCode: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return state.tokenParsed.roleCode
        } else {
            return ""
        }
    },
    getUsername: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return state.tokenParsed.preferred_username
        } else {
            return "ผู้ใช้งานทั่วไป"
        }
    },
    getSubordinateVt: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return state.tokenParsed.subordinateVt
        } else {
            return "ผู้ใช้งานทั่วไป"
        }
    },
    getUserPositionNameShort: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return state.tokenParsed.positionNameShort
        } else {
            return ""
        }
    },
    getUserProvinceName: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return state.tokenParsed.provinceName
        } else {
            return ""
        }
    },
    getUserProvinceCode: (state) => {
        if (typeof state.tokenParsed != "undefined") {
            return state.tokenParsed.provinceCode
        } else {
            return ""
        }
    },
    getIsThaidLinked: (state) => state.isThaidLinked,
    getThaidProviderUserId: (state) => state.thaidProviderUserId,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};